export default __webpack_public_path__ + "static/media/30- 24 Hrs (2).cef147ab.gif";